// Tinode config panel.
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FORCED_TRANSPORT } from '../config.js';

import CheckBox from '../widgets/checkbox.jsx';

import HostSelector from '../widgets/host-selector.jsx';

export default class SettingsView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      transport: FORCED_TRANSPORT,
      serverAddress: props.serverAddress,
      secureConnection: props.secureConnection,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleServerAddressChange = this.handleServerAddressChange.bind(this);
    this.handleToggleSecure = this.handleToggleSecure.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onUpdate({
      transport: FORCED_TRANSPORT,
      serverAddress: this.state.serverAddress,
      secureConnection: this.state.secureConnection,
    });
  }

  handleServerAddressChange(name) {
    this.setState({ serverAddress: name });
  }

  handleToggleSecure(e) {
    this.setState({ secureConnection: !this.state.secureConnection });
  }

  render() {
    return (
      <form id="settings-form" className="panel-form" onSubmit={this.handleSubmit}>
        <div className="panel-form-row">
          <label className="small">
            <FormattedMessage
              id="label_server_to_use"
              defaultMessage="Server to use:"
              description="Label for server selector in SettingsView"
            />
          </label>
        </div>
        <HostSelector serverAddress={this.state.serverAddress} onServerAddressChange={this.handleServerAddressChange} />
        <div className="panel-form-row">
          <CheckBox
            id="secure-connection"
            name="secure-connection"
            checked={this.state.secureConnection}
            className="quoted"
            onChange={this.handleToggleSecure}
          />
          <label htmlFor="secure-connection">
            <FormattedMessage
              id="label_use_secure_connection"
              defaultMessage="Use secure connection"
              description="Label for WS/WSS connection type in SettingsView"
            />
          </label>
        </div>
        <div className="dialog-buttons">
          <button type="submit" className="primary">
            <FormattedMessage id="button_update" defaultMessage="Update" description="Button [Update]" />
          </button>
        </div>
      </form>
    );
  }
}
